define([
  "marionette",
  "jquery",
  "select2",
  "./template/taskDenialNextStepsTemplate.html",
  "./template/taskDenialNextStepTemplate.html",
], function (Marionette, $, select2, TaskDenialNextStepsTemplate, TaskDenialNextStepTemplate) {
  "use strict";

  var TaskDenialNextStepsView = {};

  TaskDenialNextStepsView.denialNextStepView = Marionette.ItemView.extend({
    tagName: "tr",
    template: TaskDenialNextStepTemplate,
    className: "task-step",
    events: {
      "change .task-step-select-denial-next-step": function (e) {
        var value = $(e.target).val();
        if (!value) {
          value = 0;
        } else {
          value = +value;
        }
        this.trigger("change:denialNextStep", {
          view: this,
          model: this.model,
          value: value,
        });
      },
    },
  });

  TaskDenialNextStepsView.denialNextStepsView = Marionette.CompositeView.extend({
    template: TaskDenialNextStepsTemplate,
    itemView: TaskDenialNextStepsView.denialNextStepView,
    itemViewContainer: "tbody",
  });

  return TaskDenialNextStepsView;
});
